import { TestimonialItem } from "./TestimonialItem";

export default TestimonialItem;
